import { RegisterTypes } from 'src/app/accounts/enums/register-types.enums';
import { OnboardingIntentStep } from 'src/app/shared/enums/intent.enum';
import { OnboardingPaths } from 'src/app/shared/interfaces/intent.interface';

const BIOLAB_STEPS: OnboardingPaths = {
  [OnboardingIntentStep.Welcome]: { path: '/onboarding/biolab/welcome' },
  [OnboardingIntentStep.Register]: {
    path: '/accounts/create',
    queryParams: {
      type: RegisterTypes.LAB_BIOLAB,
    },
  },
  [OnboardingIntentStep.Newsletter]: { path: '/accounts/newsletters' },
  [OnboardingIntentStep.Caution]: { path: '/accounts/caution' },
  [OnboardingIntentStep.Check]: { path: '/accounts/verify' },
  [OnboardingIntentStep.Login]: { path: '/accounts/check' },
  [OnboardingIntentStep.Onboarding]: { path: '/onboarding/details' },
  [OnboardingIntentStep.PushNotifications]: {
    path: '/onboarding/push-notifications',
  },
  [OnboardingIntentStep.Claim]: { path: '/onboarding/biolab/details' },
  [OnboardingIntentStep.Complete]: { path: '/onboarding/biolab/complete' },
  [OnboardingIntentStep.DownloadAfterCheck]: { path: '/onboarding/download' },
  [OnboardingIntentStep.End]: { path: '/dashboard' },
};

export default BIOLAB_STEPS;
